<template>
  <div class="page container">

    <div class="row">
      <div class="col-12 text-left">
        <router-link class='btn btn-primary' to="/admin/produtos/0">Adicionar Produto</router-link>
      </div>
    </div>


 
<div class="row mt-5"  >
    <div class="col text-left">

        <h3> <b>Produtos Cadastrados</b> </h3>
        <!-- <hr/> -->

        <selecionar-produto-edit  
            v-for="produto in produtos" 
            :key="'produto'+produto.nome"
            :produto="produto" 
            :showQuatidade="false"

       />

    </div>

</div>




       
       

  </div>
</template>

<script>

import SelecionarProdutoEdit from '@/components/produtos/selecionar-produto-edit'
// import QuantidadeSelector from '@/components/elementos/quantidade-selector'

export default {
        components:{
            // QuantidadeSelector,
            SelecionarProdutoEdit
        },

        

  data(){
    return {
      error:'',
      enviado:false,
      produto:{
        id:false,
        nome:'',
        medida:'',
        incremento:'',
        preco:'',
        disponivel:0,
        informacoesadicionais:'',
      }
    }
  },




  computed:{
      listaProdutos:function(){
          return this.$store.getters.lista
      },
      produtos:function(){
          return this.$store.getters.produtos
      },
      minhacesta:function(){
          return this.$store.getters.minhacesta
      },
      total:function(){
          return this.$store.getters.total
      }
  },

  methods:{

    atualizarProduto:async function(){
      this.error = ""
    },

    cadastrarProduto:async function(){
      this.error = ""

     if(this.$refs['produto'].checkValidity()){
        let res
        debugger;
       if(this.produto.id != false){
           res = await this.$store.dispatch('updateProduto', this.produto)
       }else{
           res = await this.$store.dispatch('cadastraProduto', this.produto)
       }
        if(res!=false){
            this.enviado = true
            this.produto = {
                id:false,
                nome:'',
                medida:'',
                incremento:'',
                preco:'',
                disponivel:0,
                informacoesadicionais:'',
          }
          this.$router.replace({params:{}})
        }else{
          this.error = "Ocorreu um erro ao salvar o produto. Tente novamente."
        }
      }else{
          // alert("Preencha os dados")
          this.error = "Preencha os dados corretamente"
      }
    }
  }

}
</script>
